import React, { useState } from 'react'
import { styles } from './styles'
import { FormControl } from '@material-ui/core'
import Select from 'react-select'
import { BREAKPOINTS, COLORS, FONTS } from '../../constants'
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown'

interface ProductsSortProps {
  selectedFilter: number
  onFilterChange: (value: number) => void
}

const ItemsPerPageFilter = ({
  onFilterChange,
  selectedFilter,
}: ProductsSortProps) => {
  const classes = styles()
  const [selectedOption, setSelectedOption] = useState({
    value: selectedFilter,
    label: `${selectedFilter} items / page`,
    miniLabel: `${selectedFilter} / page`,
  })

  const options = [
    { value: 100, label: '100 items / page', miniLabel: '100 / page' },
    { value: 48, label: '48 items / page', miniLabel: '48 / page' },
    { value: 24, label: '24 items / page', miniLabel: '24 / page' },
  ]

  const handleChange = option => {
    setSelectedOption(option)
    onFilterChange(option.value)
  }

  const colourStyles = {
    control: styles => ({
      ...styles,
      backgroundColor: 'transparent',
      // width left to block flow: `width: 100%` here overflows past marginLeft
      padding: 0,
      marginLeft: 10,
      cursor: 'pointer',
      border: 'none !important',
      boxShadow: 'none',
      '&:hover': {
        border: 'none !important',
      },
    }),

    option: (styles, { isSelected, isFocused }) => {
      let backgroundColor = COLORS.white
      if (isSelected) backgroundColor = COLORS.black
      else if (isFocused) backgroundColor = COLORS.whiteStain

      return {
        ...styles,
        fontFamily: FONTS.Graphik.GraphikRegular,
        fontSize: '0.75rem',
        padding: '10px 20px',
        whiteSpace: 'nowrap',
        cursor: 'pointer',
        backgroundColor,
        color: isSelected ? COLORS.white : COLORS.black,
        ['&:active']: {
          backgroundColor: isSelected ? COLORS.black : COLORS.whiteSmoke,
        },
        [`@media (max-width: ${BREAKPOINTS.sm}px)`]: {
          padding: '10px 12px',
        },
      }
    },

    valueContainer: styles => ({
      height: 50,
    }),

    singleValue: styles => ({
      ...styles,
      top: 'unset',
      bottom: -25,
      fontFamily: FONTS.Graphik.GraphikRegular,
      fontSize: '0.75rem',
      fontWeight: 400,
      color: 'transparent',
    }),

    placeholder: styles => ({
      display: 'none',
    }),

    input: styles => ({
      color: 'transparent',
    }),

    menu: styles => ({
      ...styles,
      width: '100%',
      left: 0,
      marginTop: 2,
      borderRadius: 0,
      border: `1px solid ${COLORS.ashGrey}`,
      boxShadow: 'none',
    }),

    menuList: styles => ({
      ...styles,
      paddingTop: 0,
      paddingBottom: 0,
    }),
  }

  return (
    <div>
      <FormControl className={classes.formControl}>
        {/* fullLabel/miniLabel swap via CSS media query, not user-agent sniffing */}
        <h4 className={classes.sortByText}>
          <span className={classes.fullLabel}>
            view: {selectedOption.label}
          </span>
          <span className={classes.miniLabel}>{selectedOption.miniLabel}</span>
          <ArrowDropDownIcon />
        </h4>
        <Select
          defaultValue={selectedOption}
          value={selectedOption}
          className={classes.selectList}
          onChange={handleChange}
          options={options}
          styles={colourStyles}
          components={{
            DropdownIndicator: () => null,
            IndicatorSeparator: () => null,
          }}
          isSearchable={false}
        />
      </FormControl>
    </div>
  )
}

export default ItemsPerPageFilter
